import { buildAuthHeader, isTrustedApiUrl } from "./authToken";

/**
 * `fetch` with the session credential attached.
 *
 * Used for api calls which don't go through axios and use 'fetch' directly so that we can attach the auth header to the request.
 *
 */
export const apiFetch = (url, options = {}) => {
  if (!isTrustedApiUrl(url)) {
    // Dropping the credential is intentional for third-party hosts, but it is
    // also how a mis-set FILE_BASE_PATH shows up: the request goes out bare and
    // the server answers with its "fail" payload instead of the file.
    if (process.env.NODE_ENV !== "production") {
      console.warn(
        `[auth] ${url} is not a trusted origin, so no Authorization header was sent. ` +
          "If this is a backend file URL, add its origin to FILE_BASE_PATH in Config/Config.js.",
      );
    }
    return fetch(url, options);
  }

  const headers = new Headers(options.headers || {});
  if (!headers.has("Authorization")) {
    const authHeader = buildAuthHeader();
    if (authHeader.Authorization) {
      headers.set("Authorization", authHeader.Authorization);
    }
  }

  return fetch(url, { ...options, headers });
};

export default apiFetch;
